export const tableEmptyMessages = {
    isFilteredDataNotFound:  "Verilen kritere uygun kayıt bulunamamıştır.",
    emptyString: "",
    isEmpty: "Kayıtları listelemek için 'Hazırla' butonuna basın."
}